import { FC, ReactNode } from 'react';
import { App } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface SConModalProps {
	children: ReactNode;
	title: string;
	content: string;
	onOk: () => Promise<void>;
	onCancel?: () => void;
	disable?: boolean;
	contentNode?: ReactNode;
	okText?: string;
	cancelText?: string;
}

export const SConModal: FC<SConModalProps> = ({ children, title, content, onOk, onCancel, disable = false, contentNode, okText, cancelText }) => {
	const { t } = useTranslation();
	const { modal } = App.useApp();

	const handleClick = async (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		await modal.confirm({
			title: <span dangerouslySetInnerHTML={{ __html: title }} />,
			icon: <ExclamationCircleFilled />,
			content: contentNode || <span dangerouslySetInnerHTML={{ __html: content }} />,
			cancelText: cancelText || t('common.cancel'),
			okText: okText || t('common.confirm'),
			onOk,
			onCancel
		});
	};

	return <span onClick={(e) => !disable && handleClick(e as unknown as MouseEvent)}>{children}</span>;
};
